var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledMsgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.7083 13H1.625C0.725833 13 0 12.2742 0 11.375V1.625C0 0.725833 0.725833 0 1.625 0H15.7083C16.6075 0 17.3333 0.725833 17.3333 1.625V11.375C17.3333 12.2742 16.6075 13 15.7083 13ZM1.625 1.08333C1.32167 1.08333 1.08333 1.32167 1.08333 1.625V11.375C1.08333 11.6783 1.32167 11.9167 1.625 11.9167H15.7083C16.0117 11.9167 16.25 11.6783 16.25 11.375V1.625C16.25 1.32167 16.0117 1.08333 15.7083 1.08333H1.625Z",
    fill: "#948b9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66687 8.62301C7.90853 8.62301 7.2152 8.31968 6.6952 7.76718L1.0077 1.72218C0.801868 1.50551 0.812702 1.15885 1.02937 0.953014C1.24604 0.747181 1.5927 0.758014 1.79853 0.974681L7.48603 7.01968C8.10353 7.68051 9.2302 7.68051 9.8477 7.01968L15.5352 0.985514C15.741 0.768848 16.0877 0.758014 16.3044 0.963848C16.521 1.16968 16.5319 1.51635 16.326 1.73301L10.6385 7.77801C10.1185 8.33051 9.4252 8.63385 8.66687 8.63385V8.62301Z",
    fill: "#948b9e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledMsgIcon);
export default __webpack_public_path__ + "static/media/disabled-msg-icon.f7e2cae9facbe65c4d6dce4bd41a084f.svg";
export { ForwardRef as ReactComponent };